<template>
    <!-- Selected Partnumber -->
    <div id="selected-partnumber" :class="{ invisible: !(partnumber != null && partnumber.code.length > 0) }" v-if="partnumber != undefined && Object.keys(partnumber).length > 0 && product.StoreSaleProduct == null" style="margin-bottom: 20px;">
        {{getInterfaceText('shop_product_item#')}}
        <span v-if="partnumber != null && partnumber.code.length > 0">{{ partnumber.code }}</span>
        <span v-if="partnumber != null && partnumber.stock != null && isRetailDirectToConsumer && product.ShopActive" :class="partnumber.stock.CssClass" class="stockinfo"> | {{partnumber.stock.Label}}</span>
        <span v-if="partnumber != null && partnumber.stock != null && isRetailDirectToConsumer && isStore == false && partnumber.stock.ContainsLocalstock">
            | <a href="javascript:void(0)" class="show-dealer-selector" @click="updateShowDealerSelector">
                <span v-show="setShowDealerSelector == false">{{getInterfaceText('shop_rd2c_showretailersthathaveinstore')}}</span>
                <span v-show="setShowDealerSelector == true">{{getInterfaceText('shop_rd2c_hideretailersthathaveinstore')}}</span>
            </a>
        </span>
    </div>
</template>
<script>
    import generalMixin from '../mixins/general.js';
    import vueStore from '../store/store.js';
    export default {
        name: 'SelectedPartnumber',
        props: {
            setShowDealerSelector: Boolean
        },
        mixins: [generalMixin],
        data: function () {
            return {
                isStore: window.store.length > 0
            }
        },
        methods: {
            updateShowDealerSelector() {
                this.$emit('update:setShowDealerSelector', !this.setShowDealerSelector);
            }
        },
        computed: {
            partnumber() {
                if (vueStore.state == undefined) {
                    return null;
                }
                return vueStore.state.partnumber
            },
            isRetailDirectToConsumer() {
                return this.partnumber != null && this.partnumber.stock != null && (this.partnumber.stock.IsRetailDirectToConsumer || this.product.DirectshipmentAvailableGear == true && this.partnumber.stock.Code == 1);
            },
            product() {
                return vueStore.state.product
            }
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
        },
        watch: {
           
        }
    }
</script>
